module.exports = __webpack_public_path__ + "static/media/WINGS-BUSD.b5c12a0c.svg";